import React from "react";
import { gql } from "@apollo/client";
import { Input, Button, Modal, notification, message } from "antd";
import { UserAddOutlined, UserDeleteOutlined } from "@ant-design/icons";
import { client } from "../App";
import { MIGRATION_FEED_QUERY } from "./MigrationList";
import { DEFAULT_FEED_QUERY_LIMIT } from "../lib/pagination";

const CREATE_MIGRATION_MUTATION = gql`
  mutation findOrCreateProject(
    $companyName: String!
    $adminUserEmails: [String]
  ) {
    findOrCreateProject(
      companyName: $companyName
      adminUserEmails: $adminUserEmails
    ) {
      id
      adminUserEmails
    }
  }
`;

export class CreateMigrationModal extends React.Component {
  state = {
    companyName: "",
    visible: false,
    confirmLoading: false,
    userFieldCount: 0,
    userFields: [],
    userEmails: {},
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  closeAndResetModal = () => {
    this.setState({
      companyName: "",
      confirmLoading: false,
      visible: false,
    });
  };

  emailsValidated = () => {
    const validEmailRegex = new RegExp(
      "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
    );
    let passedValidation = true;
    this.adminUserEmails().forEach((userEmail) => {
      if (validEmailRegex.test(userEmail) == false) {
        message.error(`Email failed validation: ${userEmail}`);
        passedValidation = false;
      }
    });
    return passedValidation;
  };

  adminUserEmails = () => {
    const userEmails = this.state.userEmails;
    let emails = [];
    for (let fieldId in userEmails) {
      const userEmail = userEmails[fieldId];
      emails.push(userEmail);
    }
    return emails;
  };

  handleOk = () => {
    if (this.emailsValidated()) {
      this.setState({
        confirmLoading: true,
      });

      setTimeout(() => {
        client
          .mutate({
            mutation: CREATE_MIGRATION_MUTATION,
            variables: {
              companyName: this.state.companyName,
              adminUserEmails: this.adminUserEmails(),
            },
            refetchQueries: [
              {
                query: MIGRATION_FEED_QUERY,
                variables: { offset: 0, limit: DEFAULT_FEED_QUERY_LIMIT },
              },
            ],
          })
          .then(() => {
            notification["success"]({
              message: "Successfully created new Migration",
            });
            this.closeAndResetModal();
          })
          .catch((err) => {
            notification["error"]({
              message: "Failed to create Migration",
              description: err.message,
            });
          });
        this.setState({
          confirmLoading: false,
        });
      }, 2000);
    }
  };

  handleCancel = () => {
    this.closeAndResetModal();
  };

  handleCompanyNameInput = (e) => {
    const strippedCompanyName = e.target.value
      .replace(/[^\w\s]/gi, "")
      .replaceAll("_", " ");
    this.setState({
      companyName: strippedCompanyName,
    });
  };

  handleUserEmailInput = (e) => {
    const fieldId = e.currentTarget.id;
    const userEmails = this.state.userEmails;
    userEmails[fieldId] = e.target.value.toString().toLowerCase();
    this.setState({
      userEmails: userEmails,
    });
  };

  addUserField = () => {
    const currentUserCount = this.state.userFieldCount + 1;
    const fieldId = `user-${currentUserCount}`;
    const userFields = this.state.userFields;
    userFields.push(fieldId);
    this.setState({
      userFieldCount: currentUserCount,
      userFields: userFields,
    });
  };

  removeUserField = (e) => {
    const fieldId = e.currentTarget.dataset.fieldId;
    const userFields = this.state.userFields.filter((userFieldId) => {
      if (userFieldId != fieldId) {
        return userFieldId;
      }
    });
    const userEmails = this.state.userEmails;
    delete userEmails[fieldId];
    this.setState({
      userFields: userFields,
    });
  };

  render() {
    const { visible, confirmLoading } = this.state;
    const userFields = this.state.userFields;
    const userInputs = userFields.map((fieldId) => (
      <Input
        id={fieldId}
        key={fieldId}
        placeholder="User Email"
        onChange={this.handleUserEmailInput}
        suffix={
          <UserDeleteOutlined
            onClick={this.removeUserField}
            data-field-id={fieldId}
          />
        }
      />
    ));
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          Create New Migration
        </Button>
        <Modal
          title="Create New Migration"
          visible={visible}
          onOk={this.handleOk}
          confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
        >
          <Input
            placeholder="Company Name"
            id="companyName"
            onChange={this.handleCompanyNameInput}
            value={this.state.companyName}
            style={{ marginBottom: 20 }}
          />
          {userInputs}
          <Button
            type="dashed"
            onClick={this.addUserField}
            style={{ width: "60%" }}
          >
            <UserAddOutlined /> Add Admin User
          </Button>
        </Modal>
      </div>
    );
  }
}
